import { Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { liquorOrderApi } from "../../api/liquorOrderApi";

const keepUrlForPreview = (url) => window.setTimeout(() => URL.revokeObjectURL(url), 5 * 60 * 1000);

export const LiquorOrderPdfActions = ({ orderId, orderNumber, audience = "manager" }) => {
  const getPdf = async () => liquorOrderApi.orderPdf(orderId, audience);
  const preview = async () => {
    const previewWindow = window.open("about:blank", "_blank");
    if (!previewWindow) {
      toast.error("Allow pop-ups to preview the PDF.");
      return;
    }
    previewWindow.document.title = `${orderNumber} - Purchase Order`;
    try {
      const blob = await getPdf();
      const url = URL.createObjectURL(blob);
      previewWindow.location.href = url;
      keepUrlForPreview(url);
    } catch (error) {
      previewWindow.close();
      toast.error(error.message || "Could not open the purchase order PDF.");
    }
  };
  const download = async () => {
    try {
      const blob = await getPdf();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${orderNumber}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error.message || "Could not download the purchase order PDF.");
    }
  };

  return <div className="flex min-w-0 flex-col gap-2 sm:flex-row sm:flex-wrap">
    <Button type="button" variant="outline" className="w-full sm:w-auto" onClick={preview}><ExternalLink className="mr-2 h-4 w-4" />Preview Order PDF</Button>
    <Button type="button" variant="outline" className="w-full sm:w-auto" onClick={download}><Download className="mr-2 h-4 w-4" />Download PDF</Button>
  </div>;
};
